import React from 'react';
import PageWrapper from '../../components/UI/PageWrapper';
import NebulaInsights from '../../components/Admin/NebulaInsights/NebulaInsights';

const NebulaInsightsPage = () => (
  <PageWrapper>
    <NebulaInsights />
  </PageWrapper>
);

export default NebulaInsightsPage;
